// The server type
export const SERVER_TYPE = {
  development: {
    central: 'https://pc-test25.shein.com',
    us: 'https://pc-test25.shein.com',
    eur: 'https://pc-test25.shein.com'
  },
  production: {
    central: 'https://zpnv.shein.com',
    us: 'https://zpnv-us.shein.com',
    eur: 'https://zpnv-eur.shein.com'
  }
}

// The js server type
export const JS_SERVER_TYPE = {
  development: {
    central: 'pc-test25.shein.com',
    us: 'pc-test25.shein.com',
    eur: 'pc-test25.shein.com'
  },
  production: {
    central: 'armor.ltwebstatic.com',
    us: 'armor.ltwebstatic.com',
    eur: 'armor.ltwebstatic.com'
  }
}

// The environment type
export const DEBUG_ENV = {
  development: 'development',
  production: 'production',
}

// The store name
export const KEEP_STORE_NAME = 'si_anti_spider'

// The default anti-spider configuration
export const DEFAULT_ANTI_SPIDER = {
  riskified: {
    url: 'https://beacon.riskified.com?shop=www.shein.com'
  },
  cybersource: {
    url: 'https://h.online-metrix.net/fp/tags.js',
    match: [
      {
        matchKey: 'SHEIN_US',
        merchant: 'shein_risk_manager',
        orgId: 'k8vif92e'
      },
      {
        matchKey: 'ROMWE_US',
        merchant: 'riskromwe',
        orgId: 'k8vif92e'
      },
      {
        matchKey: 'NO_US',
        merchant: 'sheincenter',
        orgId: 'k8vif92e'
      }
    ]
  },
  forter: {
    url: 'https://armor.ltwebstatic.com/she_dist/armor-libs/forter/forter.2.31.js',
    not_us: 0
  }
}

// The metric name
export const METRIC_NAME = 'si_anti_spider_sdk_c'

// The SDK version auto change
export const SDK_VERSION = '0.0.1'

// The metric name monitor js load time
export const METRIC_NAME_MONITOR_JS_LOAD_TIME = 'si_anti_spider_sdk_mjlt'

// The metric name forter ready
export const METRIC_NAME_FORTER_READY = 'si_anti_spider_sdk_forter_ready'